module.exports = __webpack_public_path__ + "img/assessment_pic@3x.fc38ac63.png";